
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/types-and-modes",
      function () {
        return require("private-next-pages/syncs/types-and-modes.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/types-and-modes"])
      });
    }
  